var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTreeEvergreen = function SvgIconTreeEvergreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.793.89a1 1 0 0 0-1.586 0l-7.5 9.75a1 1 0 0 0 .793 1.61h1.705l-3.994 5.136A1 1 0 0 0 3 19h8v3.5a1 1 0 1 0 2 0V19h8a1 1 0 0 0 .79-1.614l-3.995-5.136H19.5a1 1 0 0 0 .793-1.61zM12 17h6.955l-3.994-5.136a1 1 0 0 1 .789-1.614h1.72L12 3.14l-5.47 7.11h1.72a1 1 0 0 1 .79 1.614L5.044 17z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTreeEvergreen;